/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PublicKeyService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get the public PEM key for a receiver
     * @param receiver
     * @returns string
     * @throws ApiError
     */
    public getPublicKey(
        receiver: string,
    ): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/public-key',
            query: {
                'receiver': receiver,
            },
        });
    }

}
